import React, { useState } from 'react';
import {ReactSVG} from "react-svg";
import 'assets/sass/dashboard/layout/Layout.scss';
import closeIcon from "../../../assets/img/common/img/icon-cancel.svg";

const SecureSiteWarning = () => {
    const isMacOS = navigator.appVersion.split("Macintosh").length > 1;
    const bookmarkShortcut = isMacOS ? 'Cmd+D' : 'Ctrl+D'
    const touchDevice = (navigator.maxTouchPoints || 'ontouchstart' in document.documentElement);
    const TEXT = `Asegurate de que la dirección sea siempre app.buenbit.com - Guardala en tus marcadores presionando ${bookmarkShortcut} para mayor seguridad.`;
    const TEXT_ONLY_TOUCHSCREEN = `Asegurate de que la dirección sea siempre app.buenbit.com - Guardala en tus marcadores para mayor seguridad.`;
    const [securitySiteWarningState, setSecuritySiteWarningState] = useState(true);

    return securitySiteWarningState
    &&
    <div className="secure-site-warning">
        <div >{touchDevice ? TEXT_ONLY_TOUCHSCREEN : TEXT}</div>
        <figure className="secure-site-warning-close" onClick={() => setSecuritySiteWarningState(null)}>
            <ReactSVG src={closeIcon} />
        </figure>
    </div>
};

export default SecureSiteWarning;
